import { useState, type FormEvent } from "react";
import type { SystemLogFilters } from "../api/systemLog";

interface Props {
  initial: SystemLogFilters;
  onApply: (filters: SystemLogFilters) => void;
}

export function SystemLogFilterBar({ initial, onApply }: Props) {
  const [subsystem, setSubsystem] = useState(initial.subsystem ?? "");
  const [since, setSince] = useState(initial.since ?? "");
  const [until, setUntil] = useState(initial.until ?? "");

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    onApply({
      subsystem: subsystem.trim() || undefined,
      since: since ? new Date(since).toISOString() : undefined,
      until: until ? new Date(until).toISOString() : undefined,
    });
  }

  function handleClear() {
    setSubsystem("");
    setSince("");
    setUntil("");
    onApply({});
  }

  return (
    <form className="filter-bar" onSubmit={handleSubmit}>
      <div className="filter-field session">
        <label htmlFor="subsystem">Subsystem</label>
        <input
          id="subsystem"
          type="text"
          placeholder="(all) — try: tool:, command:condense, dev-api"
          value={subsystem}
          onChange={(e) => setSubsystem(e.target.value)}
        />
      </div>
      <div className="filter-field">
        <label htmlFor="since">Since</label>
        <input
          id="since"
          type="datetime-local"
          value={since}
          onChange={(e) => setSince(e.target.value)}
        />
      </div>
      <div className="filter-field">
        <label htmlFor="until">Until</label>
        <input
          id="until"
          type="datetime-local"
          value={until}
          onChange={(e) => setUntil(e.target.value)}
        />
      </div>
      <div className="filter-actions">
        <button type="submit" className="btn">Apply</button>
        <button type="button" className="btn" onClick={handleClear}>
          Clear
        </button>
      </div>
    </form>
  );
}
